import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsAutorizacion from '../../../actions/autorizacionViaje';
import * as actionsMain from '../../../actions/main';
import * as actionsPersonas from '../../../actions/personas';

import VerPersonas from '../../tramites/Autorizaciones/VerPersonas';
import FormAutorizacionViaje from '../../tramites/formularios/FormAutorizacionViaje';

import getAutorizacionViajePorId from '../../../graphql/querys/tramites/getAutorizacionMenorPorId.graphql';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updateAutorizacionMenorPorId from '../../../graphql/mutations/tramites/updateAutorizacionMenorPorId.graphql';
import getAutorizacionesViajes from '../../../graphql/querys/tramites/getAutorizacionesViajes.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updateAutorizacionMenorPorId, {
    name: 'updateAutorizacion',
    options: {
      refetchQueries: [{ query: getAutorizacionesViajes }],
    },
  }),
  graphql(getUsuario)
)
class EditarAutorizacionMenor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autorizante: {},
      autorizado: {},
      responsable: {},
      numero_acta_nacimiento: '',
      fecha_creacion: '',
      vinculo_autorizante: '',
      cantidad_dias: 0,
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getAutorizacionViajePorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const autorizacion = res.data.getAutorizacionViajePorId;

        if (!this.props.autorizacionViaje.cantidad_dias) {
          this.setState(
            {
              loading: false,
              autorizantes: autorizacion.autorizantes,
              autorizado: autorizacion.autorizado,
              responsables: autorizacion.responsables,
              // tipo_autorizacion: autorizacion.tipo_autorizacion,
              numero_acta_nacimiento: autorizacion.numero_acta_nacimiento,
              desde: autorizacion.desde,
              hasta: autorizacion.hasta,
              // vinculo_autorizante: autorizacion.vinculo_autorizante,
              fecha_creacion: autorizacion.fecha_creacion,
              cantidad_dias: autorizacion.cantidad_dias,
              destinos: autorizacion.destinos,
              _id: autorizacion._id,
            },
            () => {
              if (this.props.personas.length == 0) {
                let personas = [];

                personas.push({ ...this.state.autorizado, rol: 'AUTORIZADO' });
                _.forEach(this.state.responsables, responsable => {
                  personas.push({ ...responsable, rol: 'RESPONSABLE' });
                });

                _.forEach(this.state.autorizantes, autorizante => {
                  personas.push({
                    ...autorizante.persona,
                    rol: autorizante.vinculo,
                  });
                });
                this.props.actionsPersonas.setPersonas(personas);
              }
            }
          );
        } else {
          this.setState({
            loading: false,
          });
        }
      })
      .catch(err => {
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosAutorizacion = this.guardarDatosAutorizacion.bind(this);
  }

  guardarDatosAutorizacion(datos) {
    this.setState(
      {
        ...this.state,
        vinculo_autorizante: datos.vinculo_autorizante,
        numero_acta_nacimiento: datos.numero_acta_nacimiento,
        cantidad_dias: datos.cantidad_dias,
        desde: datos.desde,
        hasta: datos.hasta,
        // tipo_autorizacion: datos.tipo_autorizacion,
        destinos: datos.destinos,
        loading: true,
      },
      function() {
        // console.log('DATOS:', datos);
        this.props.actionsAutorizacion.setAutorizacionViaje({
          numero_acta_nacimiento: datos.numero_acta_nacimiento,
          cantidad_dias: datos.cantidad_dias,
          destinos: datos.destinos,
          desde: datos.desde,
          hasta: datos.hasta,
        });
        this.editarAutoriacion();
      }
    );
  }

  guardarPersonas = () => {
    if (this.checkRestriccionRoles(this.props.personas)) {
      this.siguientePaso();
    } else {
      notification.error({
        message: 'Error en la confirmacion de la autorizacion',
        description:
          'Compruebe que todas las personas tengan un rol asignado, que exista al menos un AUTORIZADO, un AUTORIZANTE',
      });
    }
  };

  checkRestriccionRoles = personas => {
    let bandera = true;
    let autorizado = false;
    let autorizantes = false;
    let responsables = true;
    personas.forEach(persona => {
      if (persona.rol.length == 0) {
        bandera = false;
      } else {
        if (persona.rol == 'AUTORIZADO') {
          autorizado = true;
        }
        if (
          persona.rol == 'MADRE' ||
          persona.rol == 'PADRE' ||
          persona.rol == 'GUARDADOR'
        ) {
          autorizantes = true;
        }
        // if (persona.rol == 'RESPONSABLE') {
        //   responsables = true;
        // }
      }
    });
    return bandera && autorizado && autorizantes && responsables;
  };

  editarAutoriacion = () => {
    let autorizantes = [];
    let idAutorizado = '';
    let idResponsables = [];

    _.each(this.props.personas, persona => {
      if (
        persona.rol == 'MADRE' ||
        persona.rol == 'PADRE' ||
        persona.rol == 'GUARDADOR'
      ) {
        autorizantes.push({ idPersona: persona._id, vinculo: persona.rol });
      } else {
        if (persona.rol == 'AUTORIZADO') {
          idAutorizado = persona._id;
        } else {
          idResponsables.push(persona._id);
        }
      }
    });

    // console.log('PROPS ACTUALES: ', this.props);
    // console.log('STATE: ', this.state);
    let nuevaAutorizacion = {
      autorizantes: autorizantes,
      idAutorizado: idAutorizado,
      idResponsables: idResponsables,
      // tipo_autorizacion: datos.tipo_autorizacion,
      numero_acta_nacimiento: this.state.numero_acta_nacimiento,
      cantidad_dias: this.state.cantidad_dias,
      destinos: this.state.destinos,
      desde: this.state.desde,
      hasta: this.state.hasta,
      idOrganismo: this.props.data.getUsuario.organismo._id,
    };

    this.props
      .updateAutorizacion({
        variables: {
          _id: this.props.match.params.id,
          nuevaAutorizacion: nuevaAutorizacion,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(resAutorizacion => {
        notification.success({
          message: 'Actualizacion Correcta',
          description: 'Se ha registrado los nuevos datos de la autorizacion',
        });

        this.setState(
          {
            loading: false,
          },
          () => this.props.history.push('/admin/autorizaciones_viajes')
        );
      })
      .catch(err => {
        console.log('ERROR EN LA ACTUALIZACION DE LA AUTORIZACION!!!');
        console.log(err);
        this.setState({
          loading: false,
        });
        errorService(err, {
          _id: this.props.match.params.id,
          nuevaAutorizacion: nuevaAutorizacion,
        });
        Modal.error({
          title:
            'Error en la actualizacion de la autorizacion del viaje de un menor',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.props.main.step;
    paso++;
    this.setState(
      {
        ...this.state,
        step: paso,
      },
      () => {
        this.props.actionsMain.setPaso(paso);
      }
    );

    // console.log("Estoy en el paso: ", paso, " con el estado: ", this.state);
  }

  anteriorPaso() {
    let paso = this.props.main.step;
    if (paso > 0) {
      paso--;
      this.setState(
        {
          ...this.state,
          step: paso,
        },
        () => {
          this.props.actionsMain.setPaso(paso);
        }
      );
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.props.main;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Autorizacion</Breadcrumb.Item>
          <Breadcrumb.Item>Viaje de Menor</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Autorizacion Viaje
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Datos Autorizacion" />
            <Step title="Involucrados" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <VerPersonas
                history={this.props.history}
                onSubmit={this.guardarPersonas}
              />
            )}

            {step === 1 && (
              <FormAutorizacionViaje
                onSubmit={this.guardarDatosAutorizacion}
                datos={{
                  vinculo_autorizante: this.state.vinculo_autorizante,
                  numero_acta_nacimiento: this.state.numero_acta_nacimiento,
                  cantidad_dias: this.state.cantidad_dias,
                  desde: this.state.desde,
                  hasta: this.state.hasta,
                  // tipo_autorizacion: this.state.tipo_autorizacion,
                  destinos: this.state.destinos,
                }}
                config={{ creacion: false }}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsAutorizacion: bindActionCreators(actionsAutorizacion, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
  actionsPersonas: bindActionCreators(actionsPersonas, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(EditarAutorizacionMenor));
